import * as React from "react";
import DateRange from "src/share/components/DateRange/DateRange";
import { IRequestCases } from "src/share/types/case/searchCase";
import { Checkbox } from "src/share/components/Checkbox/Checkbox";
import SearchBox from "src/share/components/Filter/SearchBox";
import SortBox from "src/share/components/Filter/SortBox";
import { Row } from "reactstrap";
import { sortOptions } from "../caseView.type";

interface ICasesFilters {
  casesTotal: number;
  casesViewType: any;
  dateRange: any;
  showClearFilters: boolean;
  onClearFilters: () => void;
  onDateChange: (date: any) => void;
  onDateFocus: (date: any) => void;
  onDatePickerToogle: () => void;
  onSearchText: (text: string) => void;
  onSortChange: (sort: any) => void;
  options: IRequestCases;
  searchText: string;
  showDatePicker: boolean;
}

const CasesFilters: React.FC<ICasesFilters> = ({
  casesTotal,
  dateRange,
  showClearFilters,
  onClearFilters,
  onDateChange,
  onDateFocus,
  onDatePickerToogle,
  onSearchText,
  onSortChange,
  options,
  searchText,
  showDatePicker
}) => {
  return (
    <Row className="filters-box">
      <div className="filters-container">
        <div className="results-count">
          Results: {casesTotal} {casesTotal === 1 ? "child" : "children"}
        </div>
        <div className="case-view-serch-boxes">
          <div className="case-view-datepicker-column d-none d-lg-block">
            {showDatePicker && (
              <DateRange
                onDatesChange={onDateChange}
                onFocusChange={onDateFocus}
                focusedInput={dateRange.focus}
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
              />
            )}
          </div>
          <Checkbox
            className={"d-none d-lg-block"}
            disabled={false}
            calendarCheckbox={true}
            label="Date range"
            checked={showDatePicker}
            onChange={onDatePickerToogle}
          />
          <SearchBox onSearch={onSearchText} text={searchText} />
          <SortBox
            onSort={onSortChange}
            options={sortOptions}
            selected={options.sortName}
          />
        </div>
      </div>
      {showClearFilters && (
        <div className="results-count clr-search">
          <b onClick={onClearFilters}>Clear search</b>
        </div>
      )}
    </Row>
  );
};

export default CasesFilters;
